import * as types from './constants';

// Get Similar Creators
export const getSimilarCreatorsRequest = data => (
  { type: types.GET_SIMILAR_CREATORS_REQUEST, payload: data }
);

export const getSimilarCreatorsDone = data => (
  { type: types.GET_SIMILAR_CREATORS_DONE, payload: data }
);

export const getSimilarCreatorsFailed = (errors, error) => (
  {
    type: types.GET_SIMILAR_CREATORS_FAILED,
    payload: {
      errors_api: errors || {},
      status: error?.response?.status || null
    }
  }
);

export const getSimilarCreatorsReset = () => (
  { type: types.GET_SIMILAR_CREATORS_RESET }
);
